<template>
  <div id="cme-top" @contextmenu.prevent="" v-if="$store.state.tagData.indexOf('ext_wz_top') > -1 || is3d || specialPage">
    <div :class="['z-container', { setShow: specialPage }]" :style="{ width: is3d ? '1888px' : specialPage ? '370px' : '1200px' }">
      <ul class="icon-box fr" v-if="minMaxShow">
        <div class="line">|</div>
        <li class="setup fr close" @click="goback('close')"></li>
        <li
          :class="['setup', 'fr', minMax ? 'max' : 'normal']"
          @click="
            goback('max')
            minMax = !minMax
          "
        ></li>
        <li class="setup fr min" @click="goback('min')"></li>
      </ul>
      <div :class="['toolbar', specialPage ? 'specialPage' : '']" :style="{ color: specialPage ? 'white' : '' }">
        <div :class="['toolbar-drop', { otherDrop: specialPage, hover: showNavTop, drop: !specialPage }]" @click.stop.prevent="popShow('showNavTop')">
          <div class="drop exit dddd" ref="moreSelect" title="更多"></div>

          <div v-show="isPcCient || (!languageDrop && showNavTop)" :class="['toolbar-dropbox', { otherBox: specialPage, changeLeft: changeLeft }]">
            <div class="triangle"></div>
            <div style="max-height: 180px">
              <!-- 登录 -->
              <template v-if="specialPage ? true : tagData.indexOf('ext_wz_login') > -1">
                <!-- <div class="username exit"
                   v-if="hasLogin&&!specialPage">
                <span class="icon">
                  <img v-if="getUserPhoto"
                       :src="getUserPhoto" />
                  <img v-else
                       src="../assets/images/user_basic_photo_circle.png" />
                </span>欢迎您，
                <a @click="openWander"
                   class="blue">{{$store.state.userInfo.trueName}}</a>
              </div> -->
                <div class="exit" :class="{ hovers: specialPage }" v-if="!hasLogin" @click.prevent="handleLoginAuth">
                  <a v-if="languageData">{{ languageData.login }}</a>
                </div>
              </template>
              <!-- 注册 -->
              <template v-if="specialPage ? true : tagData.indexOf('ext_wz_register') > -1">
                <div class="line" v-if="!specialPage">|</div>
                <div class="exit language maxwid inside" :class="{ hovers: specialPage }" @click.stop="handleDownload(0)">
                  <a href="javascript:;"
                    >{{ languageData.register }}
                    <div class="dropbox" v-show="downloadShow" style="height: 126px; width: 120px; left: 50%; right: 50%; transform: translateX(-50%)">
                      <div class="triangle"></div>
                      <div class="d-item" @click.stop="register()">
                        {{ languageData.register }}
                      </div>
                      <template v-if="$route.name == 'Next'">
                        <div class="d-item" @click.stop="register('scanshare')">
                          {{ languageData.Scancodetoregister }}
                        </div>
                        <div class="d-item" @click.stop="register('share')">
                          {{ languageData.shareRegister }}
                        </div>
                      </template>
                      <div class="d-item" @click.stop="handleDownload(1, '客户端下载')">
                        {{ languageData.clientDownLoad }}
                      </div>
                    </div>
                  </a>
                </div>
              </template>
              <!-- 购物车 -->
              <template v-if="tagData.indexOf('ext_wz_cart') > -1 && !specialPage">
                <div :class="['line', 'exit', { browserWidth: !specialPage }]">|</div>
                <div :class="{ exit: true, browserWidth: !specialPage }" @click.prevent="handleShopCart()">
                  <a v-if="languageData">{{ languageData.shoppingCart }}</a>
                </div>
              </template>
              <template v-if="!isPcCient && tagData.indexOf('ext_wz_pf_app') > -1 && !specialPage">
                <div class="line">|</div>
                <div class="exit" @click.prevent="clientDrop = !clientDrop">
                  <a href="javascript:;" v-if="languageData">{{ languageData.client }}</a>
                </div>
              </template>
              <template v-if="!isPcCient && tagData.indexOf('ext_wz_pf_app') > -1 && !specialPage">
                <div class="line">|</div>
                <div class="exit" @click.prevent="clientDownDrop = !clientDownDrop">
                  <a href="javascript:;" v-if="languageData">{{ languageData.clientDownLoad }}</a>
                </div>
              </template>
              <template v-if="!isPcCient && tagData.indexOf('ext_wz_language') > -1 && !specialPage">
                <div class="line">|</div>
                <div class="exit" @click.prevent="((languageDrop = !languageDrop), (clientDrop = false))">
                  <a href="javascript:;" v-if="languageData">{{ languageData.multilingualism }}</a>
                </div>
              </template>

              <!-- 退出登录 -->
              <!-- <template v-if="hasLogin&&specialPage">
              <div class="exit"
                   :class="{ hovers: specialPage}"
                   @click.stop="handleLogout">
                <a href="javascript:;"
                   v-if="languageData">{{languageData.logOut}}</a>
              </div>
            </template> -->

              <!-- 会员 -->
              <template>
                <div class="exit" :class="{ hovers: specialPage, browserWidth: !specialPage }" @click="clickmember()">
                  <a v-if="languageData">{{ languageData.addressBook }}</a>
                </div>
              </template>
              <!-- 浏览器 -->
              <template>
                <div
                  class="exit"
                  :class="['nav-entrance', { curr: navshow, hovers: specialPage, browserWidthSpecial: !specialPage }]"
                  @mouseenter="navshow = true"
                  @mouseleave="navshow = false"
                  @click="
                    clickJump()
                    navshow = !navshow
                  "
                >
                  <a v-if="languageData">{{ languageData.websiteNavigation }}</a>
                </div>
              </template>
              <!-- 刷一刷 -->
              <template>
                <div class="exit" v-if="specialPage" :class="{ cepillo: specialPage, hovers: specialPage }" @click="Cepillauncepillo('BrushOnce')">
                  <a v-if="languageData">{{ languageData.BrushOnce }}</a>
                </div>
                <div class="exit" v-if="specialPage" :class="{ cepillo: specialPage, hovers: specialPage }" @click="Cepillauncepillo('TakeALook')">
                  <a v-if="languageData">{{ languageData.TakeALook }}</a>
                </div>
                <div class="exit" v-if="specialPage" :class="{ cepillo: specialPage, hovers: specialPage }" @click="Cepillauncepillo('LetATalk')">
                  <a v-if="languageData">{{ languageData.LetATalk }}</a>
                </div>
                <div class="exit" v-if="specialPage" :class="{ cepillo: specialPage, hovers: specialPage }" @click="Cepillauncepillo('FriendCircle')">
                  <a v-if="languageData">{{ languageData.FriendCircle }}</a>
                </div>
                <!-- <div class="exit" v-if="specialPage" :class="{ cepillo: specialPage, hovers: specialPage }" @click="Cepillauncepillo('transformWorld')">
                  <a v-if="languageData">{{ languageData.transformWorld }}</a>
                </div> -->
                <div class="exit" v-if="specialPage" :class="{ cepillo: specialPage, hovers: specialPage }" @click="Cepillauncepillo('IntelligentLive')">
                  <a v-if="languageData">{{ languageData.IntelligentLive }}</a>
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- 登录 -->
        <template v-if="!hasLogin && !specialPage">
          <div class="exit neWidth" :class="{ hovers: specialPage }" @click.prevent="handleLoginAuth">
            <a v-if="languageData">{{ languageData.login }}</a>
          </div>
        </template>
        <!-- 注册 -->
        <template v-if="specialPage ? true : tagData.indexOf('ext_wz_register') > -1">
          <!-- <div class="line neWidth" v-if="!specialPage">|</div> -->
          <div class="line outside" :class="{ hovers: specialPage, haslogin: hasLogin, nospecial: !specialPage }" v-if="!specialPage">|</div>
          <div class="exit language maxwid outside" :class="{ hovers: specialPage, haslogin: hasLogin, nospecial: !specialPage }" @click.stop="handleDownload(0)">
            <a href="javascript:;"
              >{{ languageData.register }}
              <div class="dropbox" v-show="downloadShow" style="height: 126px; width: 120px; left: 50%; right: 50%; transform: translateX(-50%)">
                <div class="triangle"></div>
                <div class="d-item" @click.stop="register()">
                  {{ languageData.register }}
                </div>
                <template v-if="$route.name == 'Next' || $route.name == 'download'">
                  <div class="d-item" @click.stop="register('scanshare')">
                    {{ languageData.Scancodetoregister }}
                  </div>
                  <div class="d-item" @click.stop="register('share')">
                    {{ languageData.shareRegister }}
                  </div>
                </template>
                <div class="d-item" @click.stop="handleDownload(1, '客户端下载')">
                  {{ languageData.clientDownLoad }}
                </div>
              </div>
            </a>
          </div>
        </template>
        <!-- 购物车 -->
        <template v-if="tagData.indexOf('ext_wz_cart') > -1 && !specialPage">
          <div class="line highWidth" v-if="!specialPage">|</div>
          <div class="exit highWidth" @click.prevent="handleShopCart()">
            <a v-if="languageData">{{ languageData.shoppingCart }}</a>
          </div>
        </template>
        <!-- 会员 -->
        <template v-if="!specialPage">
          <div class="line highWidth" v-if="!specialPage">|</div>
          <div class="exit highWidth" @click="clickmember()">
            <a v-if="languageData">{{ languageData.addressBook }}</a>
          </div>
        </template>
        <!-- 浏览器 -->
        <template v-if="!specialPage && tagData.indexOf('ext_wz_brower') > -1">
          <div class="line browserHighWidth" v-if="!specialPage">|</div>
          <div
            class="exit browserHighWidth"
            style="position: relative"
            :class="['nav-entrance', { curr: navshow, hovers: specialPage }]"
            @mouseenter="navshow = true"
            @mouseleave="navshow = false"
            @click="
              clickJump()
              navshow = !navshow
            "
          >
            <a v-if="languageData">{{ languageData.websiteNavigation }}</a>
          </div>
        </template>

        <!-- 社交管理 -->
        <template v-if="!specialPage">
          <div class="line">|</div>
          <div class="exit language" @click.stop.prevent="(popShow('vitality'), (changes = -1))" style="position: relative">
            <a href="javascript:;">
              <span>{{ languageData.dataAssets }}</span>
            </a>
            <div class="fuceng" v-show="vitality">
              <div class="triangle"></div>
              <div class="numerical-statistics">
                <!-- 共享商城配置 -->
                <!-- <div class="d-item"
                    v-if="showConfiguration"
                    @click="popularize('SharedMallConfiguration');">
                    {{languageData.SharedMallConfiguration}}
                </div> -->
                <!-- 好友圈 -->
                <div class="d-item" @click="popularize('friendCircle')">
                  {{ languageData.friendCircle }}
                </div>
                <!-- 我的名片 -->
                <div class="d-item" @click="popularize('Mybusinesscard')">
                  {{ languageData.Mybusinesscard }}
                </div>
                <!-- 我的官网 -->
                <div class="d-item">
                  {{ languageData.Myofficialwebsite }}
                </div>
                <!-- 自营世界 -->
                <div class="d-item" v-if="showConfiguration" @click="popularize('SharedWorldConfiguration')">
                  {{ languageData.SharedWorldConfiguration }}
                </div>
                <!-- 数据市场 -->
                <div class="d-item" @click="popularize('datamarket')">
                  {{ languageData.datamarket }}
                </div>
                <!-- 数字货币 -->
                <div class="d-item" @click="popularize('digitalcurrency')">
                  {{ languageData.digitalcurrency }}
                </div>
                <!-- 元气值 -->
                <div class="d-item" @click="popularize('Yuanqivalue')">
                  {{ languageData.Yuanqivalue }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 操作指导 -->
        <template>
          <div class="line" v-if="!specialPage">|</div>
          <div class="exit language xiaoyuan" :class="{ hovers: specialPage }" style="position: relative">
            <a href="javascript:;">
              <span @click.stop.prevent="popShow('addShow')">{{ languageData.xiaoyuanMedia }}</span>
            </a>
            <div class="dropbox" v-show="addShow" :style="{ width: '120px', left: '50%', right: '50%', transform: 'translateX(-50%)' }">
              <div class="triangle"></div>
              <div class="dropbox-b">
                <!-- <div class="d-item" v-for="(ite,ind) in operationGuidance" :key="ind"
                   @click="popularize('',ite);">
                   {{ite.stanardByAppNameData}}
              </div> -->
                <!-- 精准推送 -->
                <div class="d-item" @click="popularize('accuratePush')">
                  {{ languageData.accuratePush }}
                </div>
                <!-- 共享世界 -->
                <div class="d-item" @click="popularize('IntelligentReformTutorial')">
                  {{ languageData.IntelligentReformTutorial }}
                </div>
                <!-- 机器人推广 -->
                <div class="d-item" @click="popularize('Agentlevel')">
                  {{ languageData.Agentlevel }}
                </div>
                <!-- 创建话术 -->
                <div class="d-item" @click="popularize('createBoot')">
                  {{ languageData.createBoot }}
                </div>
                <!-- 生态模型 -->
                <div class="d-item" @click="popularize('EcologicalModelling')">
                  {{ languageData.EcologicalModelling }}
                </div>
                <!-- 数字人体验 -->
                <div class="d-item" @click="popularize('TheDigitalHuman')">
                  {{ languageData.TheDigitalHuman }}
                </div>
                <!-- 机器人教程 -->
                <div class="d-item" @click="popularize('RobotTutorial')">
                  {{ languageData.RobotTutorial }}
                </div>
                <!-- 顶层机器人 -->
                <div class="d-item" @click="popularize('MyMetaverse')">
                  {{ languageData.MyMetaverse }}
                </div>
                <!-- 操作系统 -->
                <div class="d-item" @click="popularize('aboutTheMetaverse')">
                  {{ languageData.aboutTheMetaverse }}
                </div>
                <!-- 培训指导 -->
                <div class="d-item" @click="popularize('trainingGuidance')">
                  {{ languageData.trainingGuidance }}
                </div>
                <!-- 元宇宙知识 -->
                <div class="d-item" @click="popularize('scriptGuidance')">
                  {{ languageData.scriptGuidance }}
                </div>
                <!-- 操作手册 -->
                <div class="d-item" @click="popularize('operatingManual')">
                  {{ languageData.operatingManual }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 刷一刷 -->
        <template>
          <div class="line" v-if="!specialPage">|</div>
          <div class="exit language" :class="{ hovers: specialPage, outcepillo: specialPage }">
            <a v-if="languageData" @click.stop.prevent="popShow('BrushOnce')">{{ languageData.extendedMetaverse }}</a>
            <div class="dropbox" v-show="BrushOnce" :style="{ width: '120px', left: '50%', right: '50%', transform: 'translateX(-50%)' }">
              <div class="triangle"></div>
              <div class="dropbox-b">
                <!-- 刷一刷 -->
                <div class="d-item" @click="Cepillauncepillo('BrushOnce')">
                  {{ languageData.BrushOnce }}
                </div>
                <!-- 看一看 -->
                <div class="d-item" @click="Cepillauncepillo('TakeALook')">
                  {{ languageData.TakeALook }}
                </div>
                <!-- 聊一聊 -->
                <div class="d-item" @click="Cepillauncepillo('LetATalk')">
                  {{ languageData.LetATalk }}
                </div>
                <!-- 好友圈 -->
                <div class="d-item" @click="Cepillauncepillo('FriendCircle')">
                  {{ languageData.FriendCircle }}
                </div>
                <!-- 抖变世界 -->
                <!-- <div class="d-item" @click="Cepillauncepillo('transformWorld')">
                  {{ languageData.transformWorld }}
                </div> -->
                <!-- 智能直播 -->
                <div class="d-item" @click="Cepillauncepillo('IntelligentLive')">
                  {{ languageData.IntelligentLive }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 设置图标 -->
        <template v-if="specialPage ? true : tagData.indexOf('ext_wz_webset') > -1">
          <div class="line" v-if="!specialPage">|</div>
          <div class="exit language" style="position: relative" :class="['nav-entrance', { curr: setshow, hovers: specialPage }]" title="设置" @click.stop.prevent="(popShow('setshow'), (nextShow = false), (languageShow = false), (personset = false), (changes = -1))">
            <a href="javascript:;">
              <img ref="setDom" v-if="!$store.state.NewYearTheme" style="position: relative; top: 2px" :src="specialPage ? require('../assets/image/images/icon_set.png') : require('../assets/image/images/top_set.png')" alt="" srcset="" />
              <!-- 过年主题 -->
              <img v-else ref="setDom" style="position: relative; top: 2px" src="../assets/image/images/set_up_white.png" alt="" srcset="" />
            </a>
            <div class="dropbox" v-show="setshow" :style="{ width: '120px', right: 0 }">
              <div class="triangle" style="left: 85%"></div>
              <template v-if="specialPage">
                <div class="d-item" @click.prevent="personalization(0, '字体大小')">字体大小</div>
                <div class="d-item" @click.prevent="personalization(1, '皮肤管理', 't')">皮肤管理</div>
                <div class="d-item" @click.prevent="personalization(6, '账户融合')">账户融合</div>
                <div class="d-item" v-show="!fourPage()" @click.prevent="personalization(2, '定位设置')">定位设置</div>
                <div class="d-item" @click.prevent="personalization(4, '密码设置')">密码设置</div>
                <div class="d-item" v-if="hasLogin" @click.stop="handleLogout">退出</div>
              </template>
              <template v-else>
                <div :class="['d-item', 'icons', { backColor: changes == 0 }]" @click.stop.prevent="that.IsMobile() ? ((nextShow = true), (languageShow = false), (personset = false)) : ''" @mouseenter="showNext()">
                  搜索配置
                  <i class="el-icon-caret-right"></i>
                </div>
                <div :class="['d-item', 'icons', { backColor: changes == 1 }]" @click.stop.prevent="that.IsMobile() ? ((languageShow = true), (nextShow = false), (personset = false)) : ''" @mouseenter="languageShows()">
                  多语言
                  <i class="el-icon-caret-right"></i>
                </div>
                <div :class="['d-item', 'icons', { backColor: changes == 2 }]" @click.stop.prevent="that.IsMobile() ? ((personset = true), (languageShow = false), (nextShow = false)) : ''" @mouseenter="personsetShows()">
                  个性化设置
                  <i class="el-icon-caret-right"></i>
                </div>
                <div :class="['d-item', 'icons', { backColor: changes == 3 }]" @click.stop="handleLogout" @mouseenter="langOut()" v-if="hasLogin && (specialPage ? true : tagData.indexOf('ext_wz_outLogin') > -1)">退出</div>
              </template>
            </div>
            <div class="dropbox" v-show="nextShow" :style="{ height: '126px', overflowY: 'auto', width: '120px', right: `${rightS}px` }">
              <div class="d-item" v-for="(set, nidx) in setList" :key="nidx" @click="openWinFrame(set, nidx)">
                {{ set.name }}
              </div>
            </div>
            <div class="dropbox" id="language" v-show="languageShow" :style="{ height: '126px', overflowY: 'auto', width: '120px', right: `${rightS}px` }">
              <div :class="['d-item', { specials: changesL == 0 }]" @click.stop.prevent="getTagsByLanguage('zhCn', 0)">
                简体中文
                <i v-show="changesL == 0" class="el-icon-check"></i>
              </div>
              <div :class="['d-item', { specials: changesL == 3 }]" @click.stop.prevent="getTagsByLanguage('zhTn', 3)">
                繁体中文
                <i v-show="changesL == 3" class="el-icon-check"></i>
              </div>
              <div :class="['d-item', { specials: changesL == 2 }]" @click.stop.prevent="getTagsByLanguage('en', 2)">
                English
                <i v-show="changesL == 2" class="el-icon-check"></i>
              </div>
              <div :class="['d-item', { specials: changesL == 1 }]" @click.stop.prevent="getTagsByLanguage('es', 1)">
                España
                <i v-show="changesL == 1" class="el-icon-check"></i>
              </div>
            </div>
            <div class="dropbox" id="language" v-show="personset" :style="{ height: '180px', overflowY: 'auto', width: '120px', right: `${rightS}px` }">
              <div class="d-item" @click.prevent="personalization(0, '字体大小')">字体大小</div>
              <div class="d-item" @click.prevent="personalization(1, '皮肤管理')">皮肤管理</div>
              <div class="d-item" @click.prevent="personalization(6, '账户融合')">账户融合</div>
              <div class="d-item" v-show="!fourPage()" @click.prevent="personalization(2, '定位设置')">定位设置</div>
              <div class="d-item" @click.prevent="personalization(4, '密码设置')">密码设置</div>
              <!-- <div class="d-item" v-if="hasLogin" @click.stop="handleLogout">退出</div> -->
            </div>
          </div>
        </template>
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import Bus from '../bus.js'
import QRCode from 'qrcodejs2'
export default {
  name: 'navTop',
  components: {
    QRCode
  },
  props: {
    is3d: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      window: window,
      changesL: sessionStorage.getItem('languageDataIndex') || 0,
      changes: -1,
      suspend: false,
      yuanqivalue: 0,
      personset: false,
      agglomerateCount: '',
      charmCount: '',
      combatEffectivenessCount: '',
      vitalityCount: '',
      wiseCount: '',
      vitality: false,
      that: this,
      window: window,
      applyJoin: false,
      rightSP: -140,
      Popover: false,
      addShow: false,
      navshow: false,
      BrushOnce: false,
      navList: [],
      showNavTop: false,
      clientDrop: false,
      languageDrop: false,
      clientDownLoadDrop: false,
      consumerExploer: [],
      setshow: false,
      setList: [
        { name: '对外搜索配置', url: '' },
        { name: '被搜索到配置', url: '' }
      ],
      nextShow: false,
      languageShow: false,
      downloadShow: false,
      rightS: -120,
      qrcodes: false,
      minMax: true,
      minMaxShow: navigator.userAgent.indexOf('Electron') > -1 && window.innerWidth >= 768 && this.$route.name == 'Next',
      electron: (navigator.userAgent.indexOf('Electron') > -1 && self != top) || self != top,
      //展示社交管理共享世界配置、共享商城配置
      showConfiguration: (this.$store.state.userInfo.id || this.$store.state.userInfo.userId) && (self != top || this.IsApp().APP),
      changeLeft: false,
      operationGuidance: []
    }
  },
  created() {
    this.fetchShowBlock()
    this.getNavTop()
    this.grade()
    // this.getSetListData();
    this.controlSite()
    if (!(self != top || this.IsApp().APP) && this.hasLogin) {
      //登录但不满足嵌APP，查询接口判断
      this.getConfiguration()
    }
    const _this = this
    window.addEventListener('resize', function () {
      _this.controlSite()
    })
    Bus.$on('popHide', () => {
      this.setshow = false
      this.nextShow = false
      this.languageShow = false
      this.addShow = false
      this.applyJoin = false
      this.personset = false
      this.showNavTop = false
      this.downloadShow = false
      this.vitality = false
      this.BrushOnce = false
    })
  },
  updated() {
    this.controlSite()
  },
  computed: {
    isPcCient() {
      var flag = true
      // if(window.innerWidth<=1200&&window.innerWidth>425){
      //   flag = false
      // }
      return flag
    },
    languageData() {
      return this.$store.state.languageData
    },
    clientData() {
      return this.$store.state.clientData
    },
    hasLogin() {
      return this.$store.state.userInfo.id || this.$store.state.userInfo.userId
    },
    tagData() {
      return this.$store.state.tagData
    },
    getUserPhoto() {
      let ph = this.$store.state.userInfo.photo || this.$store.state.userInfo.avatar
      return ph ? `https://520emv.com/cme-sso-app/showimg/${JSON.parse(ph)[0].id}` : ''
    },
    // 外展、业务、邮箱、设备页面
    specialPage() {
      var link = window.location.href.split('?')[0],
        array = ['onqid', 'oamid', 'odzid', 'zkzkid','detail'],
        flag = false
      if (array.filter((tags) => link.indexOf(tags) > -1).length) {
        flag = true
      }
      return flag
    }
  },
  methods: {
    async getConfiguration() {
      var _this = this
      var res = await _this.$http.get('/acnid-project-approve/bsysrole/checkAdmin/api/user/getRoleUserInfoListByAppId.json', {
        appId: _this.$appId,
        roleType: '1,2,3,4,5,6'
      })

      if (res.state == 1) {
        const filteredItems = Object.values(res.data)
          .reduce((acc, curr) => acc.concat(curr), []) // 将所有数组合并为一个数组
          .filter((item) => item.userId == _this.hasLogin)
        if (filteredItems.length) {
          this.showConfiguration = true
          return
        }
      }
      res = await _this.$http.get('/acnid-project-approve/bsysrole/checkAdmin/api/user/getRoleUserInfoListByAppId.json', {
        pfId: window.$pfId,
        roleType: '1'
      })
      if (res.state == 1) {
        const filteredItems = Object.values(res.data)
          .reduce((acc, curr) => acc.concat(curr), []) // 将所有数组合并为一个数组
          .filter((item) => item.userId == _this.hasLogin)
        if (filteredItems.length) {
          this.showConfiguration = true
          return
        }
      }
    },
    openWander() {
      if (location.hostname.indexOf('520ezj') == -1) {
        this.open('https://520emv.com/aassid/?appId=myb', '_blank')
      }
    },
    goback(item) {
      if (navigator.userAgent.indexOf('Electron') > -1) {
        var ipcRender = top.window.ipcRender ? top.window.ipcRender : top.window.require('electron').ipcRenderer
        //发送指令
        try {
          if (self != top && item == 'close') {
            location.href = 'about:blank;'
            return
          }
          if (self != top && item == 'max') {
            ipcRender.send('openWindow', { title: '共享世界', url: window.location.href })
            return
          }
          ipcRender.send(item)
        } catch (e) {
          console.log('不支持ipcRenderer')
        }
      }
    },
    creatNextLeave() {
      var url = this.$store.state.baseURL + '/aassid/cascadeFlow/getMainFlowList?appId=szhbpt&flowId=scgid-szhbpt-guru-flow-85503878429'
      if (this.electron) {
        //自定义工作台大小窗口切换
        this.diyWork($(parent.document))
        parent.document.getElementById('workFrame').setAttribute('src', url)
        return
      } else if (!this.hasLogin) {
        this.handleLoginAuth()
        return
      }
      this.diyWork($(frames[0][0].document))
      this.iframeOpen('MainFrame', 'workFrame', url, '数字货币')
    },
    diyWork(area) {
      //自定义工作台大小窗口切换
      var visibleChatWindow = area.find('.chat-window-frame').is(':visible')
      var visibleWorkbench = area.find('.chat-workbench-frame').is(':visible')
      var visibleChatSet = area.find('.chat-set-frame').is(':visible')
      if (!visibleChatWindow & !visibleWorkbench & visibleChatSet) {
        area.find('.chat-set-frame .windowbox .reduction').trigger('click')
      }
    },
    // 刷一刷
    Cepillauncepillo(val) {
      var url,
        name,
        aassid = location.hostname == '520ezj.com' ? '&aassid' : ''
      switch (val) {
        case 'BrushOnce':
          //刷一刷
          url = this.$store.state.baseURL + '/uoqid/odzid?isMedia=1&brush=2&isTop=true&pfId=' + window.$pfId
          name = '刷一刷'
          break
        case 'TakeALook':
          //看一看
          url = this.$store.state.baseURL + '/uoqid/odzid/look?isMedia=1&brush=2&isTop=true&pfId=' + window.$pfId
          name = '看一看'
          break
        case 'LetATalk':
          //聊一聊
          url = this.$store.state.baseURL + '/uoqid/odzid/chat?isMedia=1&brush=2&isTop=true&pfId=' + window.$pfId
          name = '聊一聊'
          break
        case 'FriendCircle':
          //好友圈
          url = this.$store.state.baseURL + '/cme-sso-app/product/circle/friends/my-circle?userId=' + (this.hasLogin ? this.hasLogin : '') + aassid
          name = '好友圈'
          break
        case 'transformWorld':
          //抖变世界
          url = this.$store.state.baseURL + '/uoqid/odzid?isMedia=1&brush=2&isTop=true&chooseSort=4&chooseInd=0&pfId=' + window.$pfId
          name = '抖变世界'
          break
        case 'IntelligentLive':
          //智能直播
          url = this.$store.state.baseURL + '/uoqid/odzid?isMedia=1&brush=2&isTop=true&chooseSort=3&chooseInd=2&pfId=' + window.$pfId
          name = '智能直播'
          break
      }
      this.open(url, '_blank', name)
    },
    // 操作指导
    popularize(val, link) {
      var iframe = this.fourPage(),
        aassid = location.hostname == '520ezj.com' ? '&aassid' : ''
      var url = ''
      if (link) {
        this.jumpArea(link.contentWzUrl, link.stanardByAppNameData, iframe)
      }
      switch (val) {
        case 'accuratePush':
          //精准推送
          url = this.$store.state.baseURL + '/zciid-deliverable/api/CatalogScrolling/catalogScrollingData?appId=jzts&pfId=' + window.$pfId + aassid
          this.jumpArea(url, '精准推送', iframe)
          break
        case 'EcologicalModelling':
          //生态模型
          url = this.$store.state.baseURL + '/zciid-deliverable/api/CatalogScrolling/catalogScrollingData?appId=stmx&pfId=' + window.$pfId + aassid
          this.jumpArea(url, '生态模型', iframe)
          break
        case 'TheDigitalHuman':
          //数字人体验
          url = this.$store.state.baseURL + '/zciid-deliverable/api/CatalogScrolling/catalogScrollingData?appId=szr&pfId=' + window.$pfId + aassid
          this.jumpArea(url, '数字人体验', iframe)
          break
        case 'IntelligentReformTutorial':
          //共享世界
          url = this.$store.state.baseURL + '/zciid-deliverable/api/CatalogScrolling/catalogScrollingData?appId=KSLJYYZ&pfId=' + window.$pfId + aassid
          this.jumpArea(url, '共享世界', iframe)
          break
        case 'RobotTutorial':
          //机器人教程
          url = this.$store.state.baseURL + '/zciid-deliverable/api/CatalogScrolling/catalogScrollingData?appId=jqrjc&pfId=' + window.$pfId + aassid
          this.jumpArea(url, '机器人教程', iframe)
          break
        case 'aboutTheMetaverse':
          //操作系统
          url = this.$store.state.baseURL + '/zciid-deliverable/api/CatalogScrolling/catalogScrollingData?appId=czss&pfId=' + window.$pfId + aassid
          this.jumpArea(url, '操作系统', iframe)
          break
        case 'operatingManual':
          //操作手册
          url = this.$store.state.baseURL + '/zciid-deliverable/api/CatalogScrolling/catalogScrollingData?appId=gyyyz&pfId=' + window.$pfId + aassid
          this.jumpArea(url, '操作手册', iframe)
          break
        case 'Agentlevel':
          //机器人推广
          url = this.$store.state.baseURL + '/zciid-deliverable/api/CatalogScrolling/catalogScrollingData?appId=jqrtg&pfId=' + window.$pfId + aassid
          this.jumpArea(url, '机器人推广', iframe)
          break

        case 'scriptGuidance':
          //元宇宙知识
          url = this.$store.state.baseURL + '/zciid-deliverable/api/CatalogScrolling/catalogScrollingData?appId=yyzzs&pfId=' + window.$pfId + aassid
          this.jumpArea(url, '元宇宙知识', iframe)
          break
        case 'createBoot':
          //创建话术
          url = this.$store.state.baseURL + '/zciid-deliverable/api/CatalogScrolling/catalogScrollingData?appId=cjyd&pfId=' + window.$pfId + aassid
          this.jumpArea(url, '创建话术', iframe)
          break
        case 'MyMetaverse':
          //顶层机器人
          url = this.$store.state.baseURL + '/zciid-deliverable/api/CatalogScrolling/catalogScrollingData?appId=hsyd&pfId=' + window.$pfId + aassid
          this.jumpArea(url, '顶层机器人', iframe)
          break
        case 'trainingGuidance':
          //培训指导
          url = this.$store.state.baseURL + '/zciid-deliverable/api/CatalogScrolling/catalogScrollingData?appId=czsc&pfId=' + window.$pfId + aassid
          this.jumpArea(url, '培训指导', iframe)
          break

        case 'SharedWorldConfiguration':
          //自营世界
          if (!this.$store.state.userInfo.userId) {
            this.handleLoginAuth()
            break
          }
          url = this.$store.state.baseURL + '/aassid/cmsclient/leftnav/getMainNavList?flag=gxzspz&pfId=' + window.$pfId + aassid
          if (this.electron) {
            //自定义工作台大小窗口切换
            this.diyWork($(parent.document))
            parent.document.getElementById('workFrame').setAttribute('src', url)
            return
          }
          if (this.IsMobile()) {
            layer.open({
              type: 2,
              title: '自营世界',
              area: ['100%', '100%'],
              content: url
            })
            return
          }
          //首页
          this.diyWork($(frames[0][0].document))
          this.iframeOpen('MainFrame', 'workFrame', url, '共享世界配置')
          break
        case 'SharedMallConfiguration':
          //共享商城配置
          if (!this.$store.state.userInfo.userId) {
            this.handleLoginAuth()
            break
          }
          url = this.$store.state.baseURL + '/aassid/cmsclient/leftnav/getMainNavList?flag=gxscpz&pfId=' + window.$pfId + aassid
          if (this.electron) {
            //自定义工作台大小窗口切换
            this.diyWork($(parent.document))
            parent.document.getElementById('workFrame').setAttribute('src', url)
            return
          }
          if (this.IsMobile()) {
            layer.open({
              type: 2,
              title: '共享商城配置',
              area: ['100%', '100%'],
              content: url
            })
            return
          }
          //首页
          this.diyWork($(frames[0][0].document))
          this.iframeOpen('MainFrame', 'workFrame', url, '共享商城配置')
          break
        case 'friendCircle':
          //好友圈

          url = this.$store.state.baseURL + '/cme-sso-app/product/circle/friends/my-circle?userId=' + (this.hasLogin ? this.hasLogin : '') + aassid
          this.jumpArea(url, '好友圈', iframe)
          break
        case 'Mybusinesscard':
          //我的名片
          url = this.$store.state.baseURL + '/caasid/cardinfo/base/preview?appId=' + this.$appId + '&pfId=' + window.$pfId + aassid
          this.jumpArea(url, '我的名片', iframe)
          break
        case 'Myofficialwebsite':
          //我的官网
          url = this.$store.state.baseURL + '/caasid/cardinfo/base/previewIntro?appId=' + this.$appId + '&pfId=' + window.$pfId + aassid
          this.jumpArea(url, '我的官网', iframe)
          break
        case 'datamarket':
          //数据市场
          url = this.$store.state.baseURL + '/uoqid/?appId=sjzcsq'
          this.jumpArea(url, '数据市场', iframe)
          break
        case 'digitalcurrency':
          //数字货币
          if (!this.$store.state.userInfo.userId) {
            this.handleLoginAuth()
            break
          }
          url = this.$store.state.baseURL + '/aassid/cascadeFlow/getMainFlowList?appId=szhbpt&flowId=scgid-szhbpt-guru-flow-85503878429'
          this.iframeOpen('MainFrame', 'toolsFrame', url, '数字货币')
          break
        case 'Yuanqivalue':
          //元气值
          if (!this.$store.state.userInfo.userId) {
            this.handleLoginAuth()
            break
          }
          url = this.$store.state.baseURL + '/aassid/cms/client/api/getVitalityCount?pfId=' + window.$pfId + aassid
          this.iframeOpen('MainFrame', 'toolsFrame', url, '元气值')
          break
      }
      this.addShow = false
      this.vitality = false
    },
    jumpArea(url, name, iframe) {
      if (this.fourPage()) {
        this.openIframe(url)
        return
      }
      if (this.specialPage && window.location.href.indexOf('blockId') > -1 && window.location.search && !this.getQuery('pfId')) {
        this.$emit('jumpUrl', { url: url })
        return
      }
      if (this.electron) {
        location.href = url
        return
      }
      this.open(url, '_blank', name, '', iframe, '', '', true)
    },
    //数字财富
    enterMall() {
      var url = window.location.origin + '/uoqid/?appId=sjzcsq'
      if (this.electron) {
        location.href = url
        return
      }
      this.open(url, '_blank')
    },
    grade() {
      var pfId = window.$pfId
      this.setList[0].url = window.location.origin + '/zciid-deliverable/video/material/horizontal/switching?blockId=831674272861782016-quote-kzmbgl'
      this.setList[1].url = window.location.origin + '/zciid-deliverable/video/material/horizontal/switching?blockId=827613612913852416-quote-managerstation-quote-kzmbgl'
      // this.setList[2].url = window.location.origin + '/zciid-deliverable/app/api/config/select/dict/data?appId=zjzszpt&types=internal_search_type';
      this.$http
        .get('/acnid-project-approve/circlestructure/businesscirclestructure/open/getBoardStatisticsByPfId.json', {
          pfId: pfId
        })
        .then((res) => {
          if (res.state == 1) {
            //凝聚值
            this.agglomerateCount = res.data.agglomerateCount
            //魅力值
            this.charmCount = res.data.charmCount
            //战力值
            this.combatEffectivenessCount = res.data.combatEffectivenessCount
            //元气值
            this.vitalityCount = res.data.vitalityCount
            //管理值
            this.wiseCount = res.data.wiseCount
            this.yuanqivalue = res.data.vitalityCount >= 1000 ? (res.data.vitalityCount >= 10000 ? (res.data.vitalityCount / 10000).toFixed(1) + 'w' : (res.data.vitalityCount / 1000).toFixed(1) + 'k') : res.data.vitalityCount
          }
        })
    },
    openIframe(link) {
      var iframe = document.getElementById('deliverable')
      iframe.setAttribute('src', link)
    },
    //升级
    updates() {
      this.open('https://520emv.com/uoqid/download?appId=zjsqe', '_self', '升级')
      // }
    },
    //申请加入
    applyJoins() {
      if (this.IsMobile()) {
        this.open(this.$store.state.baseURL + '/cme-sso-app/joinApply?pfId=' + (this.$store.state.baseURL == '520emv.com' ? 'aassid-com-613446-681157-p' : '228659633701650432'), '_self', '申请加入')
      } else {
        this.iframeOpen('MainFrame', 'toolsFrame', this.$store.state.baseURL + '/cme-sso-app/joinApply?pfId=' + (this.$store.state.baseURL == '520emv.com' ? 'aassid-com-613446-681157-p' : '228659633701650432'), '申请加入')
      }
    },
    //个人信息配置
    personalInf() {
      if (this.hasLogin) {
        this.open(window.location.origin + '/cme-sso-app/register-type', '_blank', '个人信息配置')
      } else {
        this.handleLoginAuth()
      }
    },
    qrcode() {
      if (!this.qrcodes) {
        new QRCode('qrcode', {
          width: 80,
          height: 80,
          text: this.$store.state.baseURL + '/cme-sso-app/joinPlatform?pfId=' + (this.$store.state.baseURL == '520emv.com' ? 'aassid-com-613446-681157-p' : '228659633701650432') // 设置二维码内容或跳转地址
        })
        this.qrcodes = true
      }
    },
    //浏览器
    clickJump() {
      var url = 'https://520plaza.com/?server=' + window.location.hostname
      if (this.fourPage()) {
        this.openIframe(url)
      } else if (this.specialPage && window.location.href.indexOf('blockId') > -1 && window.location.search && !this.getQuery('pfId')) {
        this.$emit('jumpUrl', { url: url })
      } else {
        this.open(url, '_blank', '浏览器')
      }
    },
    //刷一刷
    clickFriends() {
      var url = window.location.origin + '/uoqid/odzid?isMedia=1&brush=2&isTop=true&pfId=' + window.$pfId
      if (this.fourPage()) {
        this.openIframe(url)
        return
      }
      //在详情页
      if (this.specialPage && window.location.href.indexOf('blockId') > -1 && window.location.search && !this.getQuery('pfId')) {
        this.$emit('jumpUrl', { url: url })
        return
      }
      if (this.electron) {
        location.href = url
        return
      }
      this.open(url, '_blank')
    },
    //会员
    clickmember() {
      var url = window.location.origin + '/caasid/common/book?isTop=true&labelName=addressbook&pfId=' + window.$pfId
      var newUrl = window.location.origin + '/caasid/common/book?isTop=true&labelName=newMemberFriend'
      if (!this.$store.state.userInfo.userId) {
        this.handleLoginAuth()
        return
      }
      if (this.fourPage()) {
        this.openIframe(url)
        return
      }
      if (this.electron) {
        //自定义工作台大小窗口切换
        this.diyWork($(parent.document))
        parent.document.getElementById('workFrame').setAttribute('src', url)
        parent.document.getElementById('toolsFrame').setAttribute('src', newUrl)
        return
      }
      //在详情页
      if (this.specialPage && window.location.href.indexOf('blockId') > -1 && window.location.search && !this.getQuery('pfId')) {
        this.$emit('jumpUrl', { url: url })
        return
      }
      if (this.$route.name == 'flowList' || this.$route.name == 'download') {
        //更多页、下载页
        this.open(url, '_blank', '会员')
        return
      }
      if (this.$route.name == 'Next') {
        if (this.IsMobile()) {
          layer.open({
            type: 2,
            title: '会员',
            area: ['100%', '100%'],
            content: url
          })
          return
        }
        //首页
        this.diyWork($(frames[0][0].document))
        this.iframeOpen('MainFrame', 'workFrame', url, '会员')
        this.iframeOpen('MainFrame', 'toolsFrame', newUrl, '新会员好友')
      }
    },
    //根据屏幕宽度设置浮层出现位置
    controlSite() {
      if (this.$refs.setDom) {
        var left = this.$refs.setDom.getBoundingClientRect().left
        if (window.innerWidth - left < 160) {
          this.rightS = 120
        } else {
          this.rightS = -120
        }
        if (window.innerWidth - left < 140) {
          //二维码
          this.rightSP = 80
        } else {
          //二维码
          this.rightSP = -140
        }
      }

      if (this.$refs.moreSelect && window.getComputedStyle(this.$refs.moreSelect).display === 'block') {
        var left = this.$refs.moreSelect.getBoundingClientRect().left
        if (left < 40) {
          this.changeLeft = true
        } else {
          this.changeLeft = false
        }
      }
    },
    //顶部导航设置浮层
    showNext() {
      this.changes = 0
      this.nextShow = true
      this.languageShow = false
      this.personset = false
    },
    languageShows() {
      this.changes = 1
      this.nextShow = false
      this.languageShow = true
      this.personset = false
    },
    personsetShows() {
      this.changes = 2
      this.nextShow = false
      this.personset = true
      this.languageShow = false
    },
    langOut() {
      this.changes = 3
      this.nextShow = false
      this.personset = false
      this.languageShow = false
    },
    personalization(ind, name, special) {
      if (!this.$store.state.userInfo.userId) {
        this.handleLoginAuth()
        return
      }
      var url,
        pfId = window.$pfId ? window.$pfId : this.$blockGetData.getpfId()
      switch (ind) {
        case 0:
          url = window.location.origin + '/aassid/skinOrFontStyle/fontStyle?pfId=' + pfId
          break
        case 1:
          url = window.location.origin + '/zciid-deliverable/business/bAppOqmidPage/list?appId=' + this.$appId + '&pfId=' + pfId
          if (special) {
            var tid =
              this.$contentId ||
              this.getQuery('pfId') ||
              this.getQuery('docId') ||
              this.getQuery('socialId') ||
              this.getQuery('thirdUrl') ||
              this.getQuery('productUrl') ||
              this.getQuery('platformUrl') ||
              this.getQuery('deviceId') ||
              this.getQuery('devicekbId') ||
              this.getQuery('id') ||
              this.getQuery('emailId') ||
              this.getQuery('ywId') ||
              this.getQuery('exploitId')
            url = window.location.origin + '/zciid-deliverable/shell/base/theme/set?dataId=' + tid + '&userId=' + this.$store.state.userInfo.userId
          }
          break
        case 2:
          url = window.location.origin + '/cme-sso-app/location/bapplocation/list?appId=' + this.$appId
          break
        case 3:
          url = window.location.origin + '/aassid/platform/ptlist?pfId=' + pfId
          break
        case 4:
          url = window.location.origin + '/cme-sso-app/apppwd/reset'
          break
        case 5:
          url = window.location.origin + '/aassid/commomController/about?pfId=' + pfId
          break
        case 6:
          url = window.location.origin + '/zciid-deliverable/video/material/horizontal/switching?blockId=tgzid-zzsfgl-guru-block-49335822323&pfId=' + pfId
          break
        default:
          ''
      }
      this.personset = false
      if (!url) return
      if (this.fourPage()) {
        this.openIframe(url)
        return
      }
      //在详情页
      if (this.specialPage && window.location.href.indexOf('blockId') > -1 && window.location.search && !this.getQuery('pfId')) {
        this.$emit('jumpUrl', { url: url })
        return
      }
      if (this.electron) {
        location.href = url
        return
      }
      if (this.specialPage && window.location.href.indexOf('blockId') > -1 && window.location.search && !this.getQuery('pfId')) {
        this.$emit('jumpUrl', { url: url })
      } else {
        this.iframeOpen('MainFrame', 'toolsFrame', url, name)
      }
    },
    //购物车
    // handleShopCart() {
    //   var appId = this.$appId
    //   var address = window.location.pathname.split('/')[1] ? window.location.pathname.split('/')[1] : 'uoqid'
    //   var url = `${window.location.origin}${window.location.pathname.indexOf('shopCart') > 0 ? window.location.pathname : '/' + address + '/shopCart'}?shopId=${appId}`
    //   // this.routerJump('push','shopCart',{appId: appId},'购物车');
    //   if (this.electron) {
    //     //在客户端里打开的时候，弹窗打开
    //     this.iframeOpen('MainFrame', 'toolsFrame', url, '购物车')
    //   } else {
    //     //新窗口打开
    //     this.open(url, '_blank', '购物车')
    //   }
    // },
    //浮层是否显示
    popShow(ite) {
      if (this[ite]) {
        //如果显示就隐藏
        this[ite] = false
        window.$popShow = false
      } else {
        if (window.$popShow) {
          //为true说明有浮层显示
          Bus.$emit('popHide')
        } else {
          window.$popShow = true
        }
        this[ite] = true
      }
    },
    //客户端下载
    handleDownload(num, name) {
      this.clientDownLoadDrop = !this.clientDownLoadDrop
      this.clientDrop = false
      this.languageDrop = false
      if (!num) {
        this.popShow('downloadShow')
        return
      }
      if (num == 1) {
        var pathName = '/uoqid'
        if (window.location.pathname != '/') {
          pathName = `/${window.location.pathname.split('/')[1]}/`
        }
        //客户端下载
        var url = `${window.location.origin}${pathName}download?appId=${this.$appId}`
        this.open(url, '_blank', name, '', '', '', '', true)
      }

      //下级智能人
      if (num == 2) {
        var url = window.location.origin + '/aassid/cmsclient/manage/singleList'
        if (this.electron) {
          location.href = url
          return
        }
        if (!this.$store.state.userInfo.userId) {
          this.handleLoginAuth()
          return
        }

        this.iframeOpen('MainFrame', 'toolsFrame', url, name)
        return
      }
    },
    getSetListData() {
      var httpHead = document.location.hostname.indexOf('520plaza.com') > -1 ? `//${document.location.hostname}` : `/acnid-project-approve`
      this.$http
        .get(httpHead + '/api/process/app/flow.json', {
          flowId: 'scgid-sspzpt-guru-flow-31157968644',
          appId: 'sspzpt'
        })
        .then((res) => {
          if (res.state == 1) {
            this.setList = res.data
          }
        })
    },
    openWinFrame(set, ind) {
      this.nextShow = false
      if (this.electron) {
        location.href = set.url
        return
      }
      if (!this.$store.state.userInfo.userId) {
        this.handleLoginAuth()
        return
      }
      this.iframeOpen('MainFrame', 'toolsFrame', set.url, set.name)
    },
    getTagsByLanguage(lan, index) {
      sessionStorage.setItem('languageDataIndex', index)
      this.changesL = index
      if (!this.isPcCient) {
        this.showNavTop = !this.showNavTop
        this.languageDrop = !this.languageDrop
      }
      this.$store.commit('setLanguageData', lan)
      // this.$i18n.locale = lan;
      //触发Google翻译点击事件
      if (index == 0) {
        //如果等于0直接取消翻译
        $($('.goog-te-banner-frame.skiptranslate').contents().find('.goog-close-link img')).trigger('click')
      } else {
        if ($($('.goog-te-menu-frame.skiptranslate')[0]).contents().find('a').length == '3') {
          //如果有三个值index-1
          $($($($('.goog-te-menu-frame.skiptranslate')[0]).contents().find('a')[index - 1]).find('.text')).trigger('click')
        } else {
          //如果有四个值index不变
          $($($($('.goog-te-menu-frame.skiptranslate')[0]).contents().find('a')[index]).find('.text')).trigger('click')
        }
      }
      // this.setshow = false;
      // this.languageShow = false;
    },
    fetchShowBlock() {
      this.$http
        .get(
          '/zciid-deliverable/api/webapp/get/selected/datas.json',
          {
            appId: this.$appId,
            types: 'extented_wzlcpz'
          },
          'setShowBlock'
        )
        .then((res) => {
          if (res.state == 1) {
            var tagsAuth = []
            res.data.map((item) => {
              if (item.value == 'ext_wz_banner') {
                tagsAuth.push('banner')
              } else if (item.value == 'ext_wz_intro') {
                tagsAuth.push('companyIntroduce')
              } else if (item.value == 'ext_wz_library') {
                tagsAuth.push('knowledgeCenter')
              } else if (item.value == 'ext_wz_chart') {
                tagsAuth.push('smartChart')
              } else if (item.value == 'ext_wz_madia') {
                tagsAuth.push('tradeNews')
              } else {
                tagsAuth.push(item.value)
              }
            })
            this.$store.commit('setShowBlock', tagsAuth)
          }
        })
        .then(() => {
          if (top == self) {
            $('#cme-top .exit,#cme-top .toolbar-drop,#cme-top .dropbox').css('-webkit-app-region', 'no-drag')
          }
        })
    },
    getNavTop() {
      this.$http
        .get('/zciid-deliverable/showPlatformStyle/flow/api/get/getMainTopNavList.json', {
          appId: this.$appId,
          types: 'top-nav'
        })
        .then((res) => {
          if (res.state == 1) {
            this.navList = res.data
          }
        })
      this.$http
        .get('/zciid-deliverable/api/abduction/getConfigContentByTypes.json', {
          appId: location.hostname.indexOf('520ezj.com') > -1 || location.hostname.indexOf('520emv.com') > -1 ? window.$pfId : '228659633701650432',
          types: 'czzdpz'
        })
        .then((res) => {
          if (res.state == 1) {
            this.operationGuidance = res.data.contentJsonArr
          }
        })
    }
  }
}
</script>
<style lang="scss">
@import '~@/assets/css/theme/index.scss';
@import '~@/assets/css/navtop.scss';
</style>
<style lang="scss" scoped>
.navbar.FontSizeZoomWholeAndroid3,
.navbar.FontSizeZoomWhole3 {
  .navbar-libox .li.nav:first-of-type {
    @media screen and (max-width: 480px) {
      display: none !important;
    }
  }
  .plus-icon {
    @media screen and (max-width: 416px) {
      display: none !important;
    }
  }
  .nav-search {
    @media screen and (max-width: 360px) {
      display: none !important;
    }
  }
}
</style>
<style scoped>
/*放大缩小*/
.icon-box li {
  padding: 0 10px;
  cursor: pointer;
  width: 10px;
  height: 30px;
}
.icon-box .close {
  background: url('../assets/image/images/minMax/deliverable_close.png') no-repeat center center;
}
.icon-box .close:hover {
  background: url('../assets/image/images/minMax/deliverable_close-hover.png') no-repeat center center;
}
.icon-box .max {
  background: url('../assets/image/images/minMax/mail_big.png') no-repeat center 9px;
}
.icon-box .max:hover {
  background: url('../assets/image/images/minMax/mail_big-hover.png') no-repeat center 9px;
}
.icon-box .normal {
  background: url('../assets/image/images/minMax/mail_normal.png') no-repeat center 9px;
}
.icon-box .normal:hover {
  background: url('../assets/image/images/minMax/mail_normal-hover.png') no-repeat center 9px;
}
.icon-box .min {
  background: url('../assets/image/images/minMax/mail_minimum.png') no-repeat center center;
}
.icon-box .min:hover {
  background: url('../assets/image/images/minMax/mail_minimum-hover.png') no-repeat center center;
}
/* 过年主题 */
/* a,span{
  color:#fff;
} */
/* .line,.username{
  color: #fff !important;
} */
</style>
<style scoped>
/* 过年主题 */
/* .exit a:hover { 
  color: #fff !important;
}  */

.exit a:hover {
  color: #1777c6;
}
.backColor {
  color: #3aace9;
  background: #eaf1f3;
}
.specials {
  color: #3aace9;
  background: #eaf1f3;
  /* background: #eaf1f3 url('../assets/images/Checkmark.png') no-repeat right; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.setShow {
  margin: 0 !important;
}
.iconMore {
  display: none;
}
.toolbar-dropbox.changeLeft {
  left: 0 !important;
}
.toolbar-dropbox.changeLeft .triangle {
  left: 8%;
}
.toolbar .exit,
.toolbar .toolbar-dropbox .exit {
  padding: 0 10px;
}
.FontSizeZoomWholeAndroid3 .exit,
.FontSizeZoomWhole3 .exit {
  padding: 0 4px;
}
.FontSizeZoomWholeAndroid4 .exit,
.FontSizeZoomWhole4 .exit {
  padding: 0 3px;
}
.FontSizeZoomWholeAndroid5 .exit,
.FontSizeZoomWhole5 .exit {
  padding: 0 3px;
}
.FontSizeZoomWholeAndroid6 .exit,
.FontSizeZoomWhole6 .exit {
  padding: 0 0 0 1px;
}
.toolbar .otherBox .exit {
  padding: 0 8px;
}
.exit.hovers a:hover {
  color: #fff !important;
}
.toolbar-drop.otherDrop .exit.hovers:hover {
  background-color: #225da4;
}
.toolbar > .exit.hovers:hover {
  background-color: #225da4;
}
/* 数字财富开始 */
.fuceng {
  /* display: none; */
  position: absolute;
  top: 35px;
  left: 50%;
  right: 50%;
  transform: translateX(-50%);
  margin-right: -96px;
  width: 120px;
  /* padding: 5px 12px; */
  box-sizing: border-box;
  box-shadow: 0 0 5px rgb(0 0 0 / 50%);
  background: #fff;
  border-radius: 2px;
  z-index: 999;
  color: #000;
}
.triangle {
  position: absolute;
  top: -4px;
  left: calc(50% - 4px);
  margin-left: -2px;
  width: 0;
  height: 0;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  border-bottom: 4px solid #fff;
}
.rows {
  font-weight: bold;
  margin: 5px 0;
  line-height: 22px;
  height: 22px;
}
.enterMall-creat {
  color: #000;
  float: right;
  cursor: pointer;
  margin-left: 20px;
  padding-left: 15px;
  background: url('../assets/image/images/numericalDataAssetMall_img02.png') no-repeat left center;
}
.enterMall-enter {
  color: #000;
  float: right;
  cursor: pointer;
  padding-left: 15px;
  background: url('../assets/image/images/numericalDataAssetMall_img01.png') no-repeat left center;
}
.tit {
  font-size: 12px;
  color: #333;
}
.fl {
  float: left;
}
.bar-box {
  width: 63px;
  height: 6px;
  display: block;
  overflow: hidden;
  background: #ddd;
  border-radius: 10px;
  vertical-align: middle;
  margin: 7px 10px 0 9px;
}
.num {
  font-size: 12px;
  color: #333;
}
.on {
  display: block;
  height: 100%;
  border-radius: 10px;
}
.blue .on {
  width: 90%;
  background: #4c9dfb;
}
.green .on {
  width: 40%;
  background: #62d975;
}
.red .on {
  width: 70%;
  background: #ff534a;
}
.yellow .on {
  width: 20%;
  background: #ffcc00;
}
.orange .on {
  width: 50%;
  background: #ffaa33;
}

/* 数字财富结束 */
.nav-entrance {
  position: relative;
}
.layer-box {
  position: absolute;
  top: 36px;
  right: 0;
  width: 500px;
  z-index: 10;
  overflow: auto;
  min-height: 200px;
  max-height: 475px;
  background: #ffffff;
  border: 1px solid#dddddd;
}

.layer-box {
  overflow: hidden;
}
.navigator {
  overflow: auto;
  height: 240px;
}
.nav {
  font-size: 12px;
  color: #666;
  margin-right: 24px;
  line-height: 28px;
}

#cme-top .toolbar-drop .drop {
  display: none;
}
#cme-top .top-left .layer-box {
  z-index: 10000;
}
#cme-header .navbar-box .navbar-icon {
  display: none;
}
#cme-header .navbar-box .close {
  display: none;
}
#cme-header .subnav .cme-center .arrow-left {
  display: none;
}
#cme-header .subnav .cme-center .arrow-right {
  display: none;
}
#cme-top .toolbar-drop {
  float: left;
  position: relative;
  cursor: pointer;
}
@media screen and (max-width: 910px) {
  /* 过年主题 */
  /* .toolbar-drop.hover .toolbar-dropbox a{
    color:#000;
  }
  .toolbar-drop.hover .toolbar-dropbox a:hover{
    color:#c42f2c !important;
  } */
  /* 过年主题 */
  .z-container {
    width: auto !important;
    /* padding: 0 10px; */
    box-sizing: border-box;
  }
  .exit.inside {
    display: none !important;
  }
  .toolbar .exit a {
    display: block;
    /* max-width: 62px; */
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
  }
  #cme-header .navbar-box .navbar-icon {
    display: block;
    margin-top: 23px;
  }
  #cme-header .navbar-box .navbar-icon a {
    display: block;
    width: 24px;
    height: 24px;
    background: url(~@/assets/image/images/icons/navbox_navbar_icon.png) no-repeat;
  }
  #cme-header .navbar-box .navbar-mask {
    display: none;
    position: fixed;
    top: 36px;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 800;
  }
  #cme-header .navbar .navbar-libox {
    display: none;
    position: fixed;
    top: 36px;
    bottom: 0;
    right: 0;
    width: 166px;
    background: #fff;
    z-index: 801;
    padding: 30px 30px;
    text-align: center;
    overflow-y: auto;
  }
  #cme-header .navbar .navbar-libox .close {
    display: block;
    position: fixed;
    top: 46px;
    right: 201px;
    z-index: 802;
    cursor: pointer;
  }
  #cme-header .navbar .navbar-libox .close img {
    width: 14px;
  }
  #cme-header .navbar .navbar-libox .nav {
    display: block;
    margin-bottom: 20px;
    width: 100%;
    margin-left: 0;
    text-align: left;
    padding: 0;
  }
  #cme-header .navbar .navbar-libox .li .nav-nemu {
    left: 0;
  }
  #cme-top .toolbar-drop .exit {
    display: none;
  }
  #cme-top .toolbar-drop .line {
    display: none;
  }
  #cme-top .toolbar-drop .drop {
    display: block;
    float: right;
    width: 16px;
    height: 30px;
    /* margin: 11px 3px 0 0; */
    background: url(~@/assets/image/images/icons/toolbar_drop_icon.png) center center no-repeat;
    /* 过年主题 */
    /* background: url(~@/assets/image/images/icons/nav_three_white.png) center center
      no-repeat; */
  }
  #cme-top .toolbar-drop.hover .toolbar-dropbox {
    display: block;
    width: 98px;
    background: #fff;
    border: 1px solid #ddd;
    /* padding: 0 8px; */
    position: absolute;
    left: -40px;
    top: 35px;
    z-index: 16;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
  }
  #cme-top .toolbar-drop.hover .toolbar-dropbox .exit {
    display: block;
    width: 78px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
  #cme-top .toolbar-drop.hover .toolbar-dropbox .line {
    display: none;
  }
  /* .nav-entrance {
    position: unset !important;
  } */
  #cme-top .toolbar {
    position: unset !important;
  }
  .layer-box {
    left: 20px !important;
    right: 0 !important;
    width: auto !important;
  }
  #cme-header .nav-search.curr {
    width: 250px;
  }
  .toolbar-drop .exit.hovers a:hover {
    color: #3aace9 !important;
  }
  .toolbar-drop.otherDrop .exit:hover {
    background-color: #eaf1f3 !important;
  }
  .toolbar-dropbox .exit.hovers {
    color: #000;
    width: 102px !important;
  }
  .toolbar-drop.otherDrop .drop {
    background: url(~@/assets/image/images/icons/treasure_more.png) center center no-repeat !important;
    /* margin: 13px 3px 0 5px !important; */
    padding: 0 3px;
  }
  .toolbar-drop.otherDrop .drop:hover {
    background-color: #225da4 !important;
  }
  .toolbar-dropbox.otherBox {
    position: absolute;
    width: 118px !important;
    padding: 0 !important;
    left: -52px !important;
  }
  .setShow {
    width: 226px !important;
  }
}
@media screen and (max-width: 515px) {
  /* .toolbar-dropbox.otherBox {
    left: -66px !important;
  } */
  .highWidth {
    display: none;
  }
}
@media screen and (min-width: 479px) {
  .toolbar-drop .cepillo {
    display: none !important;
  }
}
@media screen and (max-width: 515px) {
  .outcepillo {
    display: none;
  }
}
@media screen and (min-width: 515px) {
  #cme-top .toolbar-drop.drop,
  .line.outside.haslogin {
    display: none;
  }
}
@media screen and (max-width: 515px) {
  .neWidth {
    display: none;
  }
  .setShow {
    width: 170px !important;
  }
}
@media screen and (max-width: 395px) {
  .browserHighWidth {
    display: none;
  }

  .setShow.z-container {
    width: 85px !important;
  }
  .toolbar .exit {
    padding: 0 3px;
  }
}
@media screen and (min-width: 450px) {
  .lowWidth {
    display: none !important;
  }
}

@media screen and (min-width: 769px) and (max-width: 992px) {
  .z-container {
    width: auto;
    margin: 0 10px;
  }
  #cme-header .navbar-box .navbar-icon {
    display: block;
    margin-top: 23px;
  }
  #cme-header .navbar-box .navbar-icon a {
    display: block;
    width: 24px;
    height: 24px;
    background: url(~@/assets/image/images/icons/navbox_navbar_icon.png) no-repeat;
  }
  #cme-header .navbar-box .navbar-mask {
    display: none;
    position: fixed;
    top: 36px;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 800;
  }
  #cme-header .navbar .navbar-libox {
    display: none;
    position: fixed;
    top: 36px;
    bottom: 0;
    right: 0;
    width: 166px;
    background: #fff;
    z-index: 801;
    padding: 30px 30px;
    text-align: center;
    overflow-y: auto;
  }
  #cme-header .navbar .navbar-libox .close {
    display: block;
    position: fixed;
    top: 46px;
    right: 201px;
    z-index: 802;
    cursor: pointer;
  }
  #cme-header .navbar .navbar-libox .close img {
    width: 14px;
  }
  #cme-header .navbar .navbar-libox .nav {
    display: block;
    margin-bottom: 20px;
    width: 100%;
    margin-left: 0;
    text-align: left;
    padding: 0;
  }
  #cme-header .navbar .navbar-libox .li .nav-nemu {
    left: 0;
  }
  /* .nav-entrance {
    position: unset !important;
  } */
  #cme-top .toolbar {
    position: unset !important;
  }
  .layer-box {
    left: 20px !important;
    right: 0 !important;
    width: auto !important;
  }
}

@media screen and (min-width: 992px) and (max-width: 1199px) {
  .z-container {
    width: auto;
    margin: 0 10px;
  }
  #cme-header .navbar-box .navbar-icon {
    display: block;
    margin-top: 23px;
  }
  #cme-header .navbar-box .navbar-icon a {
    display: block;
    width: 24px;
    height: 24px;
    background: url(~@/assets/image/images/icons/navbox_navbar_icon.png) no-repeat;
  }
  #cme-header .navbar-box .navbar-mask {
    display: none;
    position: fixed;
    top: 36px;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 800;
  }
  #cme-header .navbar .navbar-libox {
    display: none;
    position: fixed;
    top: 36px;
    bottom: 0;
    right: 0;
    width: 166px;
    background: #fff;
    z-index: 801;
    padding: 30px 30px;
    text-align: center;
    overflow-y: auto;
  }
  #cme-header .navbar .navbar-libox .close {
    display: block;
    position: fixed;
    top: 46px;
    right: 201px;
    z-index: 802;
    cursor: pointer;
  }
  #cme-header .navbar .navbar-libox .close img {
    width: 14px;
  }
  #cme-header .navbar .navbar-libox .nav {
    display: block;
    margin-bottom: 20px;
    width: 100%;
    margin-left: 0;
    text-align: left;
    padding: 0;
  }
  #cme-header .navbar .navbar-libox .li .nav-nemu {
    left: 0;
  }
  /* .nav-entrance {
    position: unset !important;
  } */
  #cme-top .toolbar {
    position: unset !important;
  }
  .layer-box {
    left: 20px !important;
    right: 0 !important;
    width: auto !important;
  }
}

@media screen and (min-width: 1200px) {
  #cme-top .toolbar-drop .toolbar-dropbox {
    display: block;
  }
  #cme-top .language .dropbox {
    position: absolute;
  }
}
@media screen and (min-width: 395px) {
  .browserWidthSpecial {
    display: none !important;
  }
}
@media screen and (min-width: 515px) {
  .browserWidth {
    display: none !important;
  }
}
@media screen and (min-width: 910px) {
  .exit.outside.hovers {
    display: none;
  }
  /* .haslogin.outside.nospecial{
    display: none;
  } */
}

#cme-top .language {
  position: relative;
}
#cme-top .language .dropbox {
  /* display: block; */
  position: absolute;
  right: -22px;
  width: 80px;
  background-color: #ffffff;
  color: #000000;
  z-index: 20;
  margin: 5px 0;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
}
#cme-top .language.maxwid .dropbox {
  width: 127px;
  left: -15px;
  max-height: 150px;
}
.dropbox .dropbox-b {
  overflow: auto;
  max-height: 180px;
}
#cme-top .language .d-item {
  padding: 5px 10px;
  line-height: 20px;
  cursor: pointer;
}
#cme-top .language .d-item:hover {
  color: #3aace9;
  background: #eaf1f3;
}
.d-item.icons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/NavTop.vue